<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-indent:0em !important; padding-top:150px;">This is a story of new, which surprisingly involves you. Whoever you are, wherever you are, at whatever stage in life you are, I do not think you believe we cease to exist after we meet our tragic demise. Not only that you do not believe it but you feel it within you; that feeling—that death is just not the end. This book will introduce a probable scenario to your life, one that might slightly change your perceptions about ‘life’ after death.</p><br/>
<p style="text-indent:0em !important;">Similar to dreaming, most certainly, we are not susceptible to feel the passing of time when we face death. If we were to wake up from a year’s long sleep that would feel like the blink of an eye. What if we were to wake up from our ‘forever’ sleep into a far and distant future? What if our predecessors were to wake us up? Could we perhaps reach for such lengths? It might seem impossible but is it improbable?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?5b6dc4da